function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6154 29.0591L26.3521 10.8812C26.3293 10.7545 26.2627 10.6399 26.164 10.5573C26.0653 10.4747 25.9407 10.4295 25.8119 10.4294H3.85534C3.72663 10.4295 3.60202 10.4747 3.50329 10.5573C3.40456 10.6399 3.33799 10.7545 3.3152 10.8812L0.0519029 29.0591C-0.0333128 29.5334 -0.0134061 30.0206 0.110219 30.4864C0.233844 30.9522 0.458175 31.3851 0.767383 31.7547C1.07659 32.1244 1.46315 32.4216 1.89977 32.6255C2.33639 32.8295 2.81245 32.9351 3.29435 32.935H26.3729C26.8548 32.9351 27.3309 32.8295 27.7675 32.6255C28.2041 32.4216 28.5907 32.1244 28.8999 31.7547C29.2091 31.3851 29.4334 30.9522 29.5571 30.4864C29.6807 30.0206 29.7006 29.5334 29.6154 29.0591Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.89348 9.33156V6.03807C9.89348 4.72784 10.414 3.47127 11.3404 2.54479C12.2669 1.61832 13.5235 1.09783 14.8337 1.09783C16.144 1.09783 17.4005 1.61832 18.327 2.54479C19.2535 3.47127 19.774 4.72784 19.774 6.03807V9.33156H20.8718V6.03807C20.8718 4.43667 20.2356 2.90087 19.1033 1.76851C17.9709 0.636152 16.4351 0 14.8337 0C13.2323 0 11.6965 0.636152 10.5642 1.76851C9.43181 2.90087 8.79565 4.43667 8.79565 6.03807V9.33156H9.89348Z",
  fill: "current"
});

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.cba991fe.svg";
export { ForwardRef as ReactComponent };